
  import {mapSectionComponents} from '@/helper/SectionHelper';
  import {getMetaTags} from '@/helper/Seo';
  import LazyHydrate from 'vue-lazy-hydration';
  import {scopeHelper} from '@/helper/ScopeHelper';

  export default {
    name: 'Jobs',
    components: {
      LazyHydrate,
    },
    layout: 'default',
    async asyncData({app, error, $cachedStrapi, redirect, route}) {
      if (route.query.redirect_to) {
        redirect(route.query.redirect_to);
        return;
      }

      // Query page from Strapi; strapi-change for findOne is required!
      const page = await $cachedStrapi.findOne('pages', 'jobs').catch((e) => {
        if (e.statusCode !== 404) {
          throw e;
        }
      });

      if (!scopeHelper(page, process.env.SCOPE_CANDIDATE)) {
        error({statusCode: 404, message: 'Page not found'});
        return;
      }

      const sections = await mapSectionComponents(
        page.sections,
        async function (section) {
          switch (section.component) {
            case 'SectionBreadcrumbs':
              section.breadcrumbs = [
                {
                  text: app.i18n.t('page.index'),
                  disabled: false,
                  to: app.localePath({
                    name: 'index',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: app.i18n.t('page.jobs'),
                  disabled: true,
                  to: app.localePath({
                    name: 'jobs',
                  }),
                  nuxt: true,
                  exact: true,
                },
              ];
              break;

            case 'SectionSeoContent':
              if (
                section.seo_content_config &&
                section.seo_content_config.seo_contents &&
                section.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  section.seo_content_config.seo_contents[0].id
                );
              }
              break;
          }
        }
      );

      const metaData = page && page.meta ? page.meta : {};

      return {
        metaData,
        sections,
      };
    },
    data() {
      return {
        metaData: {},
        sections: [],
      };
    },
    head() {
      return {
        title: this.metaData.title,
        meta: getMetaTags(this.metaData),
      };
    },
    // layout(context) {
    //   console.log('context', context);
    //   console.log(
    //     'in layout-prüfung: scope aus store',
    //     context.store.getters['scope/getScope']
    //   );
    //
    //   /* Geht so nicht
    //   console.log(
    //     'in layout-prüfung: scope aus store mit getScopeFromCookie',
    //     context.store.getters['scope/getScopeFromCookie']
    //   );
    //   */
    //
    //   return context.store.getters['scope/getScope'] ===
    //     'promotionbasis_candidate'
    //     ? 'default'
    //     : 'organization';
    //
    //   /*
    //   console.log('scope aus cookie für layout-prüfung', $cookies.get('scope'));
    //
    //   return $cookies.get('scope') === 'promotionbasis_candidate'
    //     ? 'default'
    //     : 'organization';
    //    */
    // },
  };
